import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminModulosPage } from "@/features/admin-modulos/components/AdminModulosPage";
import { permisosCatalogoQueryOptions, rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/** Ruta `/admin/modulos` · gestor de módulos (asignación por rol + overrides por usuario). */
export const Route = createFileRoute("/_authed-tw/admin/modulos")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminModulos])
      ? Promise.all([
      queryClient.ensureQueryData(rolesAdminQueryOptions),
      queryClient.ensureQueryData(permisosCatalogoQueryOptions),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminModulos]}>
      <AdminModulosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
